<div class="cont-app">
  <app-navbar [class.hide-content]="hideHeaderAndMenuBottom"></app-navbar>
  <div
    id="app-component-router-outlet"
    class="router-outlet"
    (scroll)="onScroll($event)"
    infiniteScroll
    [infiniteScrollDistance]="2"
    [infiniteScrollThrottle]="50"
    [scrollWindow]="false"
    (scrolled)="onModalScrollDown()"
  >
    <div class="content-routes" [class.desactive-zoom]="desactiveCssZoom">
      <div class="routers-views">
        <div class="views">
          <router-outlet></router-outlet>
        </div>
      </div>
      <app-footer></app-footer>
    </div>
  </div>
  <div [class.hide-content]="hideHeaderAndMenuBottom">
    <ng-container #menuBottom ></ng-container>
  </div>
  <ng-container #toast></ng-container>
  <ng-container #helpButton></ng-container>

  <ng-container #customModal></ng-container>
  <ng-container #productToast></ng-container>
  <ng-container #buyAndGetModal></ng-container>

  <ng-container #p2cPayModal></ng-container>
  <ng-container #p2cInfoModal></ng-container>
  <ng-container #p2cMobile></ng-container>
  <ng-container #mdlBolivarDigital></ng-container>
  <ng-container #mdlAddress></ng-container>
  <ng-container #openModalSubscribe></ng-container>

  <app-size-detector *ngIf="showAllComponents"></app-size-detector>
</div>

<div id="braze-add-content" class="d-none"></div>
